/** The entry form's month takes precedence over the page's presentation filter. */
export const getClaimRosterPeriod = (
  claimMonth?: string | null,
  selectedMonth?: string | null,
  currentMonth?: string | null
): string => (claimMonth || selectedMonth || currentMonth || '').slice(0, 7)
